module.exports = __webpack_public_path__ + "static/img/2.a9e9409.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/2.png
// module id = 8/Kw
// module chunks = 0